import React, {useEffect, useContext, useRef, useState} from 'react'
import _ from 'lodash'
import InputLabel from '@material-ui/core/InputLabel'
import FormControl from '@material-ui/core/FormControl'
import Select from '@material-ui/core/Select'
import {makeStyles} from '@material-ui/core/styles'
import MenuItem from '@material-ui/core/MenuItem'
import './AddNewFilter.scss'
import {ReservationConfigurationContext} from '../../context/ReservationConfiguration/ReservationConfiguration'
import TextInputField from './New Entity Filter/TextInputField'
import FListField from './FieldTypeRequiredFields/FListField'
import MultipleFieldSelect from './New Entity Filter/MultipleFieldSelect'
import {Grid} from '@material-ui/core'
import FromToWithDropdown from './New Entity Filter/FromToWithDropdown'
import CurrencyFieldType from './New Entity Filter/CurrencyFieldType'
import DateTypeField from './New Entity Filter/DateTypeField'
import YesNoTypeField from './New Entity Filter/YesNoTypeField'
import Cookies from 'js-cookie'

const useStyles = makeStyles(theme => ({
  formControl: {
    margin: theme.spacing(1),
    minWidth: '90%',
  },
  formControlCloseSection: {
    margin: theme.spacing(1),
    float: 'right',
  },
  closeButton: {
    backgroundColor: '#d9534f',
    border: '1px solid #d43f3a',
    width: '30px',
    color: '#fff',
    alignSelf: 'flex-end',
    marginTop: '10px',
    borderRadius: '4px',
    fontWeight: '900',
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
  },
  typeForSearch: {
    minWidth: 564,
  },
  multipleField: {
    minWidth: '50%',
  },
}))

export default function AddNewEntityFilter({
  addFilter,
  groupId,
  handleRemoveInput,
  onChange = (e, key, value, typeId) => {},
  fieldData,
  setFieldType = (data, index) => {},
}) {
  const classes = useStyles()
  const {
    groupFields,
    getGroupFields,
    setMultipleListFormDirty,
    multipleListFormDirty,
    filterFieldValues,
    loadFilterFieldValues,
  } = useContext(ReservationConfigurationContext)
  const [typeData, setTypeData] = useState([])
  const prevFilterLength = useRef(0)

  useEffect(() => {
    if (!_.isEmpty(fieldData)) {
      let listFilters = []
      fieldData.forEach(async (val, id) => {
        const response = await getData(val.field_id, id)
        listFilters.push(response)
      })
      setTypeData(listFilters)
    }
    // eslint-disable-next-line
  }, [])

  useEffect(() => {
    if (groupFields.data.length > 0 && addFilter.length > prevFilterLength.current) {
      setFieldType(groupFields?.data[0], addFilter.length - 1)
      prevFilterLength.current = addFilter.length
    }
    // eslint-disable-next-line
  }, [addFilter.length, groupFields])

  useEffect(() => {
    if (groupId) {
      getGroupFields({group_id: groupId, all_types: true})
    }
  }, [getGroupFields, groupId])

  useEffect(() => {
    return () => {
      setMultipleListFormDirty(false)
    }
  }, [setMultipleListFormDirty])

  const handleChange = async (e, idx) => {
    const {value} = e.target
    let result = _.find(groupFields?.data, function(obj) {
      if (obj.id === value) {
        return true
      }
    })
    setMultipleListFormDirty(true)
    Cookies.set('isChanged', 'true')
    setFieldType(result, idx)
    const res = await getData(result.id, idx)
    typeData[idx] = res
    setTypeData([...typeData])
  }

  const getData = async (fieldId, idx) => {
    let realSearch = ''
    if (fieldId) {
      const res = await loadFilterFieldValues(fieldId, realSearch, {limit: 50, page: 1})
      return {[idx]: res?.data.values}
    }
  }

  const getField = val => {
    let Fid = val.field_id
    let result = _.find(groupFields?.data, function(obj) {
      if (obj.id === Fid) {
        return true
      }
    })
    return result
  }

  const selectFieldType = (field, idx, data = null) => {
    switch (field?.type) {
      case 'TextField':
      case 'MemoField':
      case 'SignatureField':
      case 'DateFormulaField':
      case 'EmailField':
      case 'PhoneField':
      case 'AddressField':
      case 'DateDurationField':
      case 'NumericFormulaField':
        return <TextInputField type={field} onChange={onChange} idx={idx} data={data} />
      case 'YesNoField':
        return <YesNoTypeField type={field} onChange={onChange} idx={idx} data={data} />
      case 'CurrencyField':
      case 'NumericField':
        return (
          <CurrencyFieldType
            type={field}
            onChange={onChange}
            idx={idx}
            fieldData={fieldData?.list_filters_attributes}
            list={groupFields?.data}
            data={data}
          />
        )
      case 'DateField':
      case 'DateTimeField':
      case 'CreatedAtField':
        return (
          <DateTypeField
            type={field}
            onChange={onChange}
            idx={idx}
            list={groupFields?.data}
            data={data}
          />
        )
      case 'EntityListField':
      case 'MultipleEntityListField':
      case 'ApUserField':
      case 'UserStampField':
      case 'StatusField':
        const filterData = typeData.find(v => Object.keys(v).includes(idx.toString()))
        return (
          <MultipleFieldSelect
            fieldType={field}
            onChange={onChange}
            idx={idx}
            data={data}
            fieldData={_.isEmpty(fieldData) ? [] : fieldData[idx]}
            filterFieldValues={filterData ? filterData[idx] : []}
          />
        )
      case 'ListField':
      case 'MultipleListField':
        return <FListField />
      case 'NumericAutoIncrementField':
        return <FromToWithDropdown fieldType={field} onChange={onChange} idx={idx} data={data} />
      default:
        return null
    }
  }

  return (
    <div className="add-new-filter">
      {addFilter?.map((val, idx) => {
        return (
          <div key={idx}>
            <Grid row style={{marginTop: '12px'}} id={`filter_${idx}`}>
              <FormControl variant="outlined" className={classes.formControl}>
                <InputLabel id="demo-simple-select-outlined-label">Field Type</InputLabel>
                <Select
                  labelId="demo-simple-select-outlined-label"
                  id="demo-simple-select-outlined"
                  name="Field Type"
                  defaultValue={
                    val.field_id
                      ? val.field_id
                      : groupFields.data.length
                      ? groupFields.data[0].id
                      : ''
                  }
                  onChange={e => handleChange(e, idx)}
                  label="Field Type"
                >
                  {groupFields.data?.map(opt => {
                    return <MenuItem value={opt.id}>{`${opt.name}`}</MenuItem>
                  })}
                </Select>
              </FormControl>
              <FormControl variant="outlined" className={classes.formControlCloseSection}>
                <button
                  type="button"
                  className={classes.closeButton}
                  onClick={event => handleRemoveInput(idx, val, event)}
                >
                  X
                </button>
              </FormControl>
              {val.field_id && !multipleListFormDirty
                ? selectFieldType(getField(val), idx, val)
                : selectFieldType(val.fieldType, idx, val)}
            </Grid>
          </div>
        )
      })}
    </div>
  )
}
